import React, { useState } from 'react'
import mainContext from './mainContext'

const MainState = (props) => {
    const { loginUserDetails, setLoginUserDetails, snackBar, setSnackBar, dialog, setDialog } = props;
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const nth = function (d) {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };
    const [profileNavTitle, setProfileNavTitle] = useState("");
    const [inCanvas, setinCanvas] = useState("");
    const [canvasTitle, setCanvasTitle] = useState("");
    const [canvasSubTitle, setCanvasSubTitle] = useState("");
    const [userToView, setUserToView] = useState("");
    const [stateToHandle, setStateToHandle] = useState(null);
    const [pageload, setPageload] = useState(false);

    const [filterState, setFilterState] = useState({});

    return (
        <mainContext.Provider value={{
            loginUserDetails,
            setLoginUserDetails,

            nth,
            months,

            profileNavTitle,
            setProfileNavTitle,

            inCanvas,
            setinCanvas,
            canvasTitle,
            setCanvasTitle,
            canvasSubTitle,
            setCanvasSubTitle,

            userToView,
            setUserToView,

            stateToHandle,
            setStateToHandle,

            snackBar,
            setSnackBar,

            dialog,
            setDialog,

            filterState,
            setFilterState,
            pageload,
            setPageload

        }} >
            {props.children}
        </mainContext.Provider>
    )
}

export default MainState
